import { useEventCallback } from '@cian/react-utils';
import { clamp } from '../../../../../../internal/utils';
import { setValueIndex, roundValueToStep, asc } from '../../../helpers';
export function useSliderValueThumbsKeyDownEvent(_ref) {
  var props = _ref.props,
    valueState = _ref.valueState,
    marks = _ref.marks,
    setFocusIndex = _ref.setFocusIndex,
    setFocusVisibleIndex = _ref.setFocusVisibleIndex;
  return useEventCallback(function (event) {
    var step = props.step,
      min = props.min,
      max = props.max;
    var valueDerived = valueState.valueDerived,
      values = valueState.values,
      changeValue = valueState.changeValue,
      range = valueState.range;
    var index = Number(event.currentTarget.getAttribute('data-index'));
    var value = values[index];
    var tenPercents = (max - min) / 10;
    var marksValues = marks.map(function (mark) {
      return mark.value;
    });
    var marksIndex = marksValues.indexOf(value);
    var newValue;
    var increaseKey = 'ArrowRight';
    var decreaseKey = 'ArrowLeft';
    switch (event.key) {
      case 'Home':
        newValue = min;
        break;
      case 'End':
        newValue = max;
        break;
      case 'PageUp':
        if (step) {
          newValue = value + tenPercents;
        }
        break;
      case 'PageDown':
        if (step) {
          newValue = value - tenPercents;
        }
        break;
      case increaseKey:
      case 'ArrowUp':
        if (step) {
          newValue = value + step;
        } else {
          newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
        }
        break;
      case decreaseKey:
      case 'ArrowDown':
        if (step) {
          newValue = value - step;
        } else {
          newValue = marksValues[marksIndex - 1] || marksValues[0];
        }
        break;
      default:
        return;
    }

    // Prevent scroll of the page
    event.preventDefault();
    if (step) {
      newValue = roundValueToStep(newValue, step, min);
    }
    newValue = clamp(newValue, min, max);
    if (range) {
      var previousValue = newValue;
      newValue = setValueIndex({
        values: values,
        source: valueDerived,
        newValue: newValue,
        index: index
      }).sort(asc);
      setFocusIndex(newValue.indexOf(previousValue));
    }
    setFocusVisibleIndex(index);
    changeValue(newValue);
  });
}